<div class="env-custom-property">
  <div class="env-custom-property__header">
    <h5 class="bz-font-weight--semibold">{{ 'ENVIRONMENT.PROPERTIES' | translate }}</h5>
    <bzg-button-primary [icon]="'icon-plus'" [size]="'m'" (click)="addProperty()" class="env-custom-property__add">{{'ENVIRONMENT.ADD_PROPERTY' | translate}}</bzg-button-primary>
  </div>
  <div class="env-custom-property__table">
    <div class="env-custom-property__table-info" [ngClass]="language === 'en' ? 'language-en' : 'language-es'">
      <table #dataTable style="width:100%">
      </table>
    </div>
  </div>
</div>
